module.exports = __webpack_public_path__ + "img/joinus-2.42cfa142.png";